export const maxAvatarSize = 1048576
